/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { isArray } from 'lodash';
import React, { useEffect, useState, useMemo, memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Row,
  Label,
  Col,
  Alert,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { updateSipPri, getPbxStatus, updatePbxStatus, updateNumberRouteAndTrunk,getSipPri } from '../../../../../actions/EpikBoxes';
import { getAddress } from '../../../../../actions/Provisioning';
import utils from '../../../../../lib/utils';

import AddPRINumber from '../../../../AddPRINumber';
import AvailablePRI from '../../../../AvailablePRI';
import BoxAutocomplete from '../../../BoxAutocomplete';
import SipPriDiagnostics from '../EpikboxSipPri/SipPriDiagnostics';
import diagnosticIcon from '../../../../../Res/Icon/priSipDiagnotic.png';
import activated from '../../../../../Res/Icon/activated.png';
import { sipPriDiagnosticsPort } from '../../../../../actions/EpikBoxes';

import './BoxSip.css';
import { E911AddressModal } from './components/E911Modal';
import Spinner from '../../../../Spinner/Spinner';
import ConfirmationModal from '../../../../ConfirmationModal';
import Checkbox from '../../../../Checkbox';
import CustomWarning from '../../../../CustomWarning';
import { userRoles } from '../../../../../utils/constants';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import InfoPopup from '../../../../InfoPopup';
import Toggle from '../../../../Toggle/index';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';


const filterAlreadyAssignedNumbers = (numbers, selectedNumbers) => {
  return numbers.filter(num => {
    return !selectedNumbers.find(number => {
      return number.numRef === num._id;
    });
  });
};

export const EUpdateActions = {
  CLEAR_E911: '1',
  SUBMIT: '2',
  ADD_ASSIGN: '3',
  PBX_CHANGE: '4',
};
const PRI_COMMANDS_LIST = [
  { label: 'Software Diagnostic', value: 'SoftwareDiagnostic' },
  { label: 'dump', value: 'dump' },
  { label: 'Hardware Diagnostic', value: 'Hardware Diagnostic' },
  { label: 'Full-log -- undebug all', value: 'fullLog' },
  { label: 'Running log - condensed -- Debug voice summary', value: 'voice_summary' },
  { label: 'Running log - all -- debug voice verbose', value: 'active_call_monitoring' },
  { label: 'Running log - PRI -- Debug isdn l2-formatted', value: 'pri_isdn' },
  { label: 'PRI Signaling Status', value: 'priSignalStatus' },
  // { label: 'PRI Signaling Status', value: 'test_fun' },
]
const SIP_COMMANDS_LIST = [
  { label: "sofia Status", value: 'sofiaStatus' },
  { label: "show Calls Status", value: 'show Calls' },
]

const EpikboxSip = memo(
  ({
    title,
    onImportConfirm,
    importFinalList,
    onAssignAvailablePress,
    finalSelectedList,
    numberToFilter,
    updatePriSipSetting,
    numberSettings,
    MainTitle,
  }) => {
    const dispatch = useDispatch();
    const box = useSelector(state => state.AppState.boxDetails.box);
    const assignedNumbers = useSelector(state => state.AppState.obis.assignedNumbers);
    const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
    const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);
    const user = useSelector(state => state.AppState.user);
    
    const portActivatedPri = priSettings?.portActivated;
    const portActivatedSip = sipSettings?.portActivated;

    const [warningModal, setWarningModal] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [availableModal, setAvailableModal] = useState(false);
    const [isDiagnoticOpen, setIsDiagnoticOpen] = useState(false);
    const [isOpen, setIsopen] = useState(false);
    const [callerIdName, setCallerIdName] = useState('');
    const [callerIdNumber, setCallerIdNumber] = useState('');
    const [dtmfSettings, setDTMFSettings] = useState('');
    const [dnis, setDnis] = useState('');
    const [modifyNumberModal, setModifyNumberModal] = useState(false);
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [updatedSelectNumbers, setUpdatedSelectNumbers] = useState([]);
    const [isNumberModify, setIsNumberModify] = useState(null);
    const [priSipDiagnoticData, setPriSipDiagnoticData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pbx, setPbx] = useState(false);
    const [pbxWarning, setPbxWarning] = useState(false);
    const [boxDetails, setBoxDetails] = useState(box);
    const [inband, setInband] = useState(false);
    const [internationalDialing, setInternationalDialing] = useState();
    const internationalDialingAccess = getPermissionForComponent('internationalDialingAccess',user.permissionsGroup);

    useEffect(() => {
      setBoxDetails(box);
    }, [box]);

    const updateSipPriSettings_ = async (token, boxId, isPri, settings_) => {
      try {
        setIsLoading(true);
        await dispatch(updateSipPri(token, boxId, isPri, settings_));
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    const [isE911ModalOpen, setIsE911Modal] = useState(false);
    const [selectedE911Id, setSelectedE911Id] = useState('');
    const [pendingE911Number, setPendingE911Number] = useState('');
    const [isE911Verified, setIsE911Verified] = useState(false);
    const checkThirdOctet = parseInt(boxDetails?.vpnAddress?.split('.')[2], 10) >= 20;

    const numbers = useMemo(() => {
      const isSipModal = !!(MainTitle === 'CAS Trunking');
      const numbers_ = isSipModal
        ? sipSettings?.numberSettings?.numbers
        : priSettings?.numberSettings?.numbers;
      return numbers_?.length
        ? numbers_?.map(val => ({
          number: val.number,
          _id: val.numRef,
        }))
        : [];
    }, [sipSettings, priSettings]);

    const settings = useMemo(() => {
      const isSipModal = !!(MainTitle === 'CAS Trunking');
      return isSipModal ? sipSettings : priSettings;
    }, [sipSettings, priSettings]);

    const [selectedE911Number, setSelectedE911Number] = useState('');

    const isAddressVerifiedFromApi = e911Response => {
      if (e911Response?.statusCode === '200') return true;
      const payload = e911Response?.entry_query || e911Response || {};
      const requiredFields = ['address1', 'city', 'state', 'zip'];
      return requiredFields.every(field => `${payload?.[field] || ''}`.trim().length > 0);
    };

    const initialStateSet = () => {
      setSelectedE911Number(settings?.e911Number || '');
      setIsE911Verified(false);
      setCallerIdName(settings?.numberSettings?.callerIdName);
      setCallerIdNumber(settings?.numberSettings?.callerIdNumber);
      setDnis(settings?.numberSettings?.dnis);
      setUpdatedSelectNumbers(settings?.numberSettings?.numbers || []);
      setDTMFSettings(settings?.numberSettings?.dtmfType || 'RFC 2833');
      setInband(settings?.inband || false);
      setInternationalDialing(settings?.numberSettings?.internationalDialing || false);
    }
    useEffect(() => {
      initialStateSet()
    }, [sipSettings, priSettings,settings]);

    const onCancel = useCallback(() => {
      setIsE911Modal(false);
      setSelectedE911Id('');
      setPendingE911Number('');
    }, []);

    const handleNumbersAutoComplete = e => {
      const { suggestion, value } = e || {};
      if (suggestion) {
        setIsE911Verified(false);
        setPendingE911Number(value);
        setIsE911Modal(true);
        setSelectedE911Id(suggestion?._id);
      }
    };

    const verifyE911Address = useCallback(
      async numberId => {
        if (!numberId) {
          setIsE911Verified(false);
          return false;
        }
        const token = utils.getAuthToken();
        const response = await dispatch(getAddress(token, numberId));
        const verified = isAddressVerifiedFromApi(response);
        setIsE911Verified(verified);
        return verified;
      },
      [dispatch],
    );

    const handleE911AddressSaved = useCallback(
      async (confirmedNumber, confirmedNumberId) => {
        setSelectedE911Number(confirmedNumber);
        await verifyE911Address(confirmedNumberId || selectedE911Id);
        setIsE911Modal(false);
        setSelectedE911Id('');
        setPendingE911Number('');
      },
      [selectedE911Id, verifyE911Address],
    );

    const updateNumberSettings = async (
      assignedNum,
      unassignedNumbers,
      mode = EUpdateActions.SUBMIT,
      isPortActivate = false,
    ) => {
      const isPRI = !(MainTitle === 'CAS Trunking');
      const numberSetting = {
        callerIdName,
        callerIdNumber,
        dnis,
        numbers: isArray(assignedNum) ? assignedNum : settings?.numberSettings?.numbers,
        unassignedNumbers,
        dtmfType: dtmfSettings,
        internationalDialing:internationalDialing ? internationalDialing : false
      };
      const updatedSettings = { ...settings };
      updatedSettings.e911Number = selectedE911Number;
      if (mode === EUpdateActions.CLEAR_E911) {
        const shippedAddress_ = {
          street1: '',
          street2: '',
          attn: '',
          city: '',
          state: '',
          zip: '',
        };
        updatedSettings.shippedAddress = { ...shippedAddress_ };
        updatedSettings.e911Number = '';
      }
      updatedSettings.numberSettings = { ...numberSetting };
      const token = utils.getAuthToken();
      if (mode === EUpdateActions.SUBMIT && !selectedE911Number) {
        toast.error('Please Enter E911 Number');
        return;
      }
      if (mode === EUpdateActions.SUBMIT && selectedE911Number && !isE911Verified) {
        toast.error('Please verify E911 address before submitting');
        return;
      }
      if( mode === EUpdateActions.PBX_CHANGE ){
        updatedSettings.pbx = !settings.pbx
      }

      if (isPortActivate) {
        updatedSettings.portActivated = true;
        updatedSettings.portActivatedDate = new Date();

        if (!updatedSettings?.numberSettings?.numbers?.length) {
          toast.error('Please assign numbers before activating the port');
          return;
        }
      }

      updatedSettings.inband = inband;

      await updateSipPriSettings_(token, boxDetails._id, isPRI, updatedSettings);
      await dispatch(updateNumberRouteAndTrunk(token, boxDetails._id));
      if (mode === EUpdateActions.CLEAR_E911 || mode === EUpdateActions.ADD_ASSIGN) return;
      setIsopen(!isOpen);
      setWarningModal(true);
    };

    const getSelectNumber = (mode = EUpdateActions.ADD_ASSIGN, isPortActivate = false) => {
      let finalList = [];
      let unassignedNumbers = null;
      if (isNumberModify) {
        finalList = updatedSelectNumbers?.filter(item => selectedNumbers?.includes(item.numRef));
        unassignedNumbers = updatedSelectNumbers?.filter(
          item => !selectedNumbers?.includes(item.numRef),
        );
      }
      if (!isNumberModify) {
        const values = assignedNumbers?.filter(item => selectedNumbers?.includes(item._id));
        const dummyArry = [...updatedSelectNumbers, ...values];

        const removeDuplicate = dummyArry.filter(
          (thing, index, self) => index === self.findIndex(t => t.number === thing.number),
        );

        finalList = removeDuplicate?.map(items => {
          return {
            numRef: items?._id || items?.numRef,
            number: items?.number,
            numberType: title?.toLowerCase(),
          };
        });
      }
      setUpdatedSelectNumbers([...finalList]);
      updateNumberSettings([...finalList], unassignedNumbers, mode, isPortActivate);
    };

    const handleClearE911Num = () => {
      setIsE911Verified(false);
      getSelectNumber(EUpdateActions.CLEAR_E911);
    };

    /*
    redundant useEffect. Creating issues
    useEffect(() => {
      setCallerIdName(numberSettings?.callerIdName || '');
      setCallerIdNumber(numberSettings?.callerIdNumber || '');
      setDnis(dnis || numberSettings?.dnis || 3);
      setUpdatedSelectNumbers(numberSettings?.numbers || []);
      setDTMFSettings(numberSettings?.dtmfType || 'Inband');
    }, [numberSettings]);
    */
    const handlePriSipDiagnotic = () => {
      setIsDiagnoticOpen(true);
      if (title === 'PRI') {
        setPriSipDiagnoticData(PRI_COMMANDS_LIST);
      }
      if (title === 'SIP') {
        setPriSipDiagnoticData(SIP_COMMANDS_LIST);
      }
    };

    const onPbxSave = () => {
      setPbxWarning(true);
    };

    const allowPbx = async () => {
      const vpn = boxDetails?.vpnAddress;
      const token = utils.getAuthToken();
      const bid = boxDetails?._id;
      setIsLoading(true);
      await updateNumberSettings(undefined,undefined, EUpdateActions.PBX_CHANGE)
      setIsLoading(false);
      setPbxWarning(false);
    };

    const handleActivatePort = async () => {
      console.log('handleActivatePort called');

      getSelectNumber(EUpdateActions.ADD_ASSIGN, true);
      setModifyNumberModal(false);
    }

    const portActivated = MainTitle === 'CAS Trunking' ? portActivatedSip : portActivatedPri;

    return (
      <>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="boxPortContainer">
            <div style={{ width: '100%' }}>
              {portActivated ? (
                <div  className='iconsHeaderContainer'>
                  <div className="portActivatedIcon">
                      <TooltipIcon
                        tipId={`${title?.toLowerCase()}_activationStatus`}
                        imgSrc={activated}
                        displayData='Port Activated'
                        placement={'right'}
                        customStyle={{
                          height: '20px',
                          }}
                        customClass='portActivatedTooltip'
                      />
                  </div>
                </div>
              ) : null}

            </div>
            <div 
            // onClick={() => setIsopen(!isOpen)}>
            onClick={async () => {
              const token = utils.getAuthToken();
              const isPRI = !(MainTitle === 'CAS Trunking');
              setIsLoading(true);
              await dispatch(getSipPri(token, boxDetails._id, isPRI));
              const activeSettings = isPRI ? priSettings : sipSettings;
              const currentE911Number = activeSettings?.e911Number;
              if (currentE911Number) {
                const matchedE911Number = activeSettings?.numberSettings?.numbers?.find(
                  item => item?.number === currentE911Number,
                );
                if (matchedE911Number?.numRef) {
                  await verifyE911Address(matchedE911Number.numRef);
                } else {
                  setIsE911Verified(false);
                }
              } else {
                setIsE911Verified(false);
              }
              setIsLoading(false);
              setIsopen(true); 
            }}>
              <div className="portLabel" id={title?.toLowerCase()}>{title}</div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>CID Number</h5>
                </div>
                <span>{settings?.numberSettings?.callerIdNumber || '-'}</span>
              </div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>DNIS</h5>
                </div>
                <span>{settings?.numberSettings?.dnis || '-'}</span>
              </div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>Numbers Assigned</h5>
                </div>
                <span>{settings?.numberSettings?.numbers?.length.toString() || '0'}</span>
              </div>
            </div>
            {checkThirdOctet && (
              (title === 'PRI' || title === 'SIP') && (
                user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin ? (
                  <div className="icon-right">
                    <p onClick={handlePriSipDiagnotic}>
                      <img src={diagnosticIcon} style={{ width: '18px' }} alt="Diagnostic Icon" />
                    </p>
                  </div>
                ) : null
              )
            )}


            <Modal isOpen={isOpen}>
              <ModalHeader tag="div" className="p-3 pri-case-modal-header">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h5 className="modal-title mb-0">{MainTitle}</h5>
                  <Button color={!portActivated ? "primary" : 'success'} disabled={portActivated} size="sm" onClick={handleActivatePort}>
                    {!portActivated ? 'Activate Port' : 'Activated'}
                  </Button>
                </div>
              </ModalHeader>

              <ModalBody>
                <Row className="number-list-row">
                  <Col md={5} sm={6}>
                    <h6 className="type-header">Number Assignment</h6>
                  </Col>
                </Row>
                  {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) && 
                    <div className=" under-line">
                      <Row className="number-list-row">
                        <Col md={6} sm={6} className="mb-2">
                          <Button
                            color="primary"
                            onClick={() => {
                              onAssignAvailablePress();
                              setIsNumberModify(false);
                              setAvailableModal(true);
                              setSelectedNumbers([]);
                            }}
                          >
                            Assign Available Numbers
                          </Button>
                        </Col>
                        <Col md={6} sm={6} className="mb-2">
                          <Button
                            color="secondary"
                            onClick={() => {
                              onAssignAvailablePress();
                              setModifyNumberModal(true);
                              setIsNumberModify(true);
                              setSelectedNumbers([]);
                            }}
                          >
                            Modify Assigned Numbers
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  }
                <div className="bd-container height-list">
                    {settings?.numberSettings?.numbers?.length ? (
                      <Row className="number-list-row">
                        <Col md={{ size: 12 }} sm={{ size: 6 }}>
                          {numbers?.map(item => {
                            return <Label style={{ marginRight: '25px' }}>{item?.number}</Label>;
                          })}
                        </Col>
                      </Row>
                    ) : (
                      <div>
                        <h6>No Assigned numbers</h6>
                      </div>
                    )}
                </div>
                {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) &&
                    <>
                      <Row style={{ paddingTop: 25, borderTop: '1px solid #777' }}>
                        <Col sm={6} md={4}>
                          <Label className="sip-input-label">DNIS</Label>
                        </Col>
                        <Col sm={6} md={5}>
                          <Input
                            type="select"
                            value={dnis}
                            className="filter-append-dropdown"
                            onChange={e => setDnis(e.currentTarget.value)}
                          >
                            <option key="3" value="3">
                              3
                            </option>
                            <option key="4" value="4">
                              4
                            </option>
                            <option key="5" value="5">
                              5
                            </option>
                            <option key="6" value="6">
                              6
                            </option>
                            <option key="7" value="7">
                              7
                            </option>
                            <option key="8" value="8">
                              8
                            </option>
                            <option key="9" value="9">
                              9
                            </option>
                            <option key="10" value="10">
                              10
                            </option>
                          </Input>
                        </Col>
                      </Row>
                      <div style={{ paddingBottom: '20px', paddingTop: '15px' }}>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col>
                            <Label className="sip-heading ">Outbound Caller ID</Label>
                          </Col>
                        </Row>
                        <div className="sip-section ">
                          <Row className="sip-input">
                            <Col sm={6} md={6}>
                              <Label className="ml-3 mt-2" check>
                                <Input
                                  disabled={settings?.pbx}
                                  type="checkbox"
                                  checked={settings?.pbx}
                                // value={item?._id || item.numRef}
                                />
                                Allow Caller ID from PBX
                              </Label>
                            </Col>
                            <Col sm={6} md={4}>
                              <Button color="primary" onClick={onPbxSave}>
                              {!settings?.pbx ? "Allow" : "Disable"} PBX
                            </Button>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm={12} md={12}>
                            <Label for="error" className="pbx-error">
                              {pbxStatusError}
                            </Label>
                          </Col>
                        </Row> */}
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label for="number" className="sip-input-label">
                              Number
                            </Label>
                          </Col>
                          <Col sm={6} md={5}>
                            <Input
                              disabled={settings?.pbx}
                              onChange={e => setCallerIdNumber(e.target.value)}
                              required
                              value={callerIdNumber}
                              type="text"
                              name="number"
                            />
                          </Col>
                        </Row>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label className="sip-input-label">
                              DTMF Settings{' '}
                              <span style={{ display: 'inline-block' }}>
                                <InfoPopup id="dtmf-settings-outbound-info" text="Default method: RFC 2833" />
                              </span>
                            </Label>
                          </Col>
                          <Col sm={6} md={5}>
                            <Input
                              type="select"
                              value={dtmfSettings}
                              className="filter-append-dropdown"
                              onChange={e => setDTMFSettings(e.currentTarget.value)}
                            >
                              <option key="Edge Device Name" value="Inband">
                                Inband
                              </option>
                              <option key="Status" value="RFC 2833">
                                RFC 2833
                              </option>
                            </Input>
                          </Col>
                        </Row>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label className="sip-input-label">E911 Number</Label>
                          </Col>
                          <Col sm={5}>
                            {numbers?.length > 0 ? (
                              <>
                                <BoxAutocomplete
                                  placeholder="Filter Numbers"
                                  searchTerm={selectedE911Number}
                                  numbers={numbers}
                                  onChange={handleNumbersAutoComplete}
                                />
                              </>
                            ) : (
                              <Label className="sip-input-label one-line-text">
                                {' '}
                                No Assigned number Selected{' '}
                              </Label>
                            )}
                          </Col>
                          <Col sm={2}>
                            {numbers.length > 0 && (
                              <Button color="primary" onClick={handleClearE911Num}>
                                Clear
                              </Button>
                            )}
                          </Col>
                        </Row>
                        {numbers?.length > 0 && selectedE911Number && (
                          <Row style={{ paddingTop: '4px' }}>
                            <Col sm={{ size: 5, offset: 4 }}>
                              {isE911Verified ? (
                                <span style={{ color: '#28a745' }}>
                                  <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    size="lg"
                                    color="#28a745"
                                    style={{ marginRight: '0.5rem' }}
                                  />
                                  Address Verified
                                </span>
                              ) : (
                                <span style={{ color: '#dc3545', fontWeight: 600 }}>
                                  Address not verified
                                </span>
                              )}
                            </Col>
                          </Row>
                        )}
                        {!selectedE911Number && title === 'PRI' && (
                          <Row style={{ paddingTop: '10px' }}>
                            <Col sm={12} md={11}>
                              <Alert color="warning" className="mb-0 py-2">
                                No E911 information stored for PRI.
                              </Alert>
                            </Col>
                          </Row>
                        )}
                      </div>
                      </div>
                    {internationalDialingAccess && (
                      <Row className="align-items-center intlDialRow">
                        <Col
                          xs="auto"
                          className="d-flex align-items-center pr-2"
                          style={{ minWidth: "170px" }}
                        >
                          <Label className="sip-input-label intlDialLabel mb-0 text-nowrap">
                            International Dialing
                          </Label>
                        </Col>

                        <Col xs="auto" className="d-flex align-items-center">
                          <div className="intlDialToggleWrap">
                            <Toggle
                              thumbAnimateRange={[1, 28]}
                              value={internationalDialing}
                              onToggle={() => setInternationalDialing(prev => !prev)}
                              disabled={(internationalDialingAccess === "read" )}
                            />
                          </div>
                        </Col>
                      </Row>
                    )}
                      <div style={{ paddingBottom: '20px', paddingTop: '15px' }}>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col>
                            <Label className="sip-heading ">Inbound Call Settings</Label>
                          </Col>
                        </Row>
                        <div className="sip-section ">
                          <Row style={{ paddingTop: '5px' }}>
                            <Col sm={6} md={4}>
                              <Label className="sip-input-label">
                                DTMF Settings{' '}
                                <span style={{ display: 'inline-block' }}>
                                  <InfoPopup id="dtmf-settings-inbound-info" text="Default method: Inband" />
                                </span>
                              </Label>
                            </Col>
                            <Col sm={6} md={5}>
                              <Input
                                type="select"
                                value={inband ? 'Inband' : 'RFC 2833'}
                                className="filter-append-dropdown"
                                onChange={e => {
                                  const value = e.currentTarget.value;
                                  setInband(value === 'Inband');
                                }}
                              >
                                <option key="Inband" value="Inband">
                                  Inband
                                </option>
                                <option key="RFC 2833" value="RFC 2833">
                                  RFC 2833
                                </option>
                              </Input>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </>
                }  
                {/* <div style={{ paddingBottom: '20px' }}>
                  <Row style={{ paddingTop: '5px' }}>
                    <Col>
                      <Label className="sip-heading ">Failore Settings</Label>
                    </Col>
                  </Row>
                  <div className="sip-secition">
                    <Row style={{ paddingTop: '5px' }}>
                      <Col sm={6} md={4}>
                        <Label className="sip-input-label">Failore Device #1</Label>
                      </Col>
                      <Col sm={6} md={5}>
                        <Input
                          type="select"
                          value={failoreDevice1}
                          className="filter-append-dropdown"
                          onChange={e => setFailoreDevice1(e.currentTarget.value)}
                        >
                          <option key="Edge Device Name" value="IP Auth">
                            IP Auth
                          </option>
                          <option key="Status" value="Username/Password">
                            Username/Password
                          </option>
                          ]
                        </Input>
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: '5px' }}>
                      <Col sm={6} md={4}>
                        <Label className="sip-input-label">Failore Device #2</Label>
                      </Col>
                      <Col sm={6} md={5}>
                        <Input
                          type="select"
                          value={failoreDevice2}
                          className="filter-append-dropdown"
                          onChange={e => setFailoreDevice2(e.currentTarget.value)}
                        >
                          <option key="Edge Device Name" value="IP Auth">
                            IP Auth
                          </option>
                          <option key="Status" value="Username/Password">
                            Username/Password
                          </option>
                        </Input>
                      </Col>
                    </Row>
                  </div>
                </div> */}
              </ModalBody>
              {/*  footer */}
              <ModalFooter>
                <Button
                  outline
                  color="secondary"
                  onClick={() => {
                    setIsopen(!isOpen);
                    setIsNumberModify(null);
                    initialStateSet()
                  }}
                >
                    {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) ? 'Cancel' : 'Close'}
                </Button>
                {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) && 
                   <Button color="primary" onClick={updateNumberSettings}> Submit  </Button>
                }
              </ModalFooter>
            </Modal>
            <AddPRINumber
              data={boxDetails}
              importNumberList={importFinalList}
              isOpen={modalStatus}
              onCancel={() => {
                setModalStatus(false);
                setIsNumberModify(null);
              }}
              onConfirm={() => {
                onImportConfirm();
                setModalStatus(false);
              }}
            />
            <SipPriDiagnostics
              data={priSipDiagnoticData}
              title={title}
              isOpen={isDiagnoticOpen}
              box={boxDetails}
              setIsOpen={setIsDiagnoticOpen}
            />

            <AvailablePRI
              // phone={this.props.phone}
              setSelectedNumbers={setSelectedNumbers}
              numberToFilter={numberToFilter}
              finalSelectedList={finalSelectedList}
              data={filterAlreadyAssignedNumbers(assignedNumbers, updatedSelectNumbers)}
              isOpen={availableModal}
              onCancel={() => setAvailableModal(false)}
              onConfirm={() => {
                getSelectNumber(EUpdateActions.ADD_ASSIGN);
                setAvailableModal(false);
              }}
            />

            <AvailablePRI
              // phone={this.props.phone}
              selectedNumbers={selectedNumbers}
              setSelectedNumbers={setSelectedNumbers}
              numberToFilter={numberToFilter}
              isNumberModify={isNumberModify}
              finalSelectedList={finalSelectedList}
              data={updatedSelectNumbers}
              isOpen={modifyNumberModal}
              onCancel={() => setModifyNumberModal(false)}
              onConfirm={() => {
                getSelectNumber(EUpdateActions.ADD_ASSIGN);
                setModifyNumberModal(false);
              }}
            />
            {isE911ModalOpen && (
              <E911AddressModal
                isOpen={isE911ModalOpen}
                onCancel={onCancel}
                numberId={selectedE911Id}
                numberTitle={pendingE911Number}
                isTypeSip={!!(MainTitle === 'CAS Trunking')}
                settings={settings}
                onSuccess={handleE911AddressSaved}
              />
            )}
          </div>
        )}
        <ConfirmationModal
          bodyText="Please reboot this device for changes to take effect."
          isOpen={warningModal}
          onCancel={() => setWarningModal(false)}
          ignoreConfirmButton
          close
        />
        <CustomWarning
          // loading={activateLoading || saveLoading}
          isOpen={pbxWarning}
          onCancel={() => setPbxWarning(false)}
          onConfirm={allowPbx}
        >
          The settings will be saved and the page will need to be refreshed to commit this change.
          Are you sure you want to proceed?
        </CustomWarning>
      </>
    );
  },
);

export default EpikboxSip;
